module.exports = __webpack_public_path__ + "img/28-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA9.9904796d.jpg";